/**
 * 微信授权登录类型
 */
export enum WECHAT_SCAN_TYPE {
    /**绑定用户 */
    BINDING_USER = "BINDING_USER",

    /**注册供货商 */
    REGISTER_SUPPLIER = "REGISTER_SUPPLIER",

    LOGIN = "LOGIN",

    /**供货商登录发货易 */
    SUPPLIER_LOGIN = "SUPPLIER_LOGIN",

    /** 自由独立版登录 */
    INDEPENDENT_MANUAL_LOGIN = "INDEPENDENT_MANUAL_LOGIN",

    /** 自由打印版注册 */
    REGISTER_INDEPENDENT_MANUAL = "REGISTER_INDEPENDENT_MANUAL",
}

export const WeChatScanStateMainContentMapping = {
    [WECHAT_SCAN_TYPE.LOGIN]: "login",
    [WECHAT_SCAN_TYPE.SUPPLIER_LOGIN]: "supplier_login",
    [WECHAT_SCAN_TYPE.INDEPENDENT_MANUAL_LOGIN]: "independent_manual_login",
    [WECHAT_SCAN_TYPE.REGISTER_SUPPLIER]: "register_supplier",
    [WECHAT_SCAN_TYPE.REGISTER_INDEPENDENT_MANUAL]: "register",
};

interface BindingUserParams {
    type: WECHAT_SCAN_TYPE.BINDING_USER;

    state: string;
}

export interface RegisterSupplierParams {
    type: WECHAT_SCAN_TYPE.REGISTER_SUPPLIER;

    mobile?: string;

    /** 重定向url */
    urlPath: string;
}

interface LoginParams {
    type: WECHAT_SCAN_TYPE.LOGIN;
}

export interface SupplierLoginParams {
    type: WECHAT_SCAN_TYPE.SUPPLIER_LOGIN;

    /** 重定向url */
    urlPath: string;
}

export interface RegisterIndependentManualParams {
    type: WECHAT_SCAN_TYPE.REGISTER_INDEPENDENT_MANUAL;
    urlPath: string;
    mobile: string;
}

export interface IndependentManualLoginParams {
    type: WECHAT_SCAN_TYPE.INDEPENDENT_MANUAL_LOGIN;
}

/**
 * 根据不同场景，获取对应场景下的微信授权登录链接
 */
function getWechatIframeUrl(params: LoginParams): string;
function getWechatIframeUrl(params: SupplierLoginParams): string;
function getWechatIframeUrl(params: RegisterSupplierParams): string;
function getWechatIframeUrl(params: BindingUserParams): string;
function getWechatIframeUrl(params: RegisterIndependentManualParams): string;
function getWechatIframeUrl(params: IndependentManualLoginParams): string;
function getWechatIframeUrl(
    params:
        | BindingUserParams
        | RegisterSupplierParams
        | LoginParams
        | SupplierLoginParams
        | RegisterIndependentManualParams
        | IndependentManualLoginParams,
): string {
    const search = new URLSearchParams();

    search.set("redirect_uri", "https://main.fahuoyi.com/wechat/login");
    search.set("appid", "wxb4e0d35c482273be");
    search.set("response_type", "code");
    search.set("scope", "snsapi_login");
    search.set("connect_redirect", "1");

    let prefix = "V2_";
    if (import.meta.env.MODE === "testServer") {
        prefix = "V2TEST_";
    }

    if (params.type === WECHAT_SCAN_TYPE.BINDING_USER) {
        search.set("state", params.state);
    }

    if (params.type === WECHAT_SCAN_TYPE.LOGIN) {
        search.set("state", `${prefix}${WeChatScanStateMainContentMapping[WECHAT_SCAN_TYPE.LOGIN]}`);
    }

    if (params.type === WECHAT_SCAN_TYPE.INDEPENDENT_MANUAL_LOGIN) {
        search.set("state", `${prefix}${WeChatScanStateMainContentMapping[WECHAT_SCAN_TYPE.INDEPENDENT_MANUAL_LOGIN]}`);
    }

    if (params.type === WECHAT_SCAN_TYPE.SUPPLIER_LOGIN) {
        search.set(
            "state",
            `${prefix}${WeChatScanStateMainContentMapping[WECHAT_SCAN_TYPE.SUPPLIER_LOGIN]}_${params.urlPath}`,
        );
    }

    if (params.type === WECHAT_SCAN_TYPE.REGISTER_SUPPLIER) {
        search.set(
            "state",
            `${prefix}${WeChatScanStateMainContentMapping[WECHAT_SCAN_TYPE.REGISTER_SUPPLIER]}_${params.mobile}_${
                params.urlPath
            }`,
        );
    }

    if (params.type === WECHAT_SCAN_TYPE.REGISTER_INDEPENDENT_MANUAL) {
        search.set(
            "state",
            `${prefix}${WeChatScanStateMainContentMapping[WECHAT_SCAN_TYPE.REGISTER_INDEPENDENT_MANUAL]}_${
                params.mobile
            }_${params.urlPath}`,
        );
    }

    return `https://open.weixin.qq.com/connect/qrconnect?${search.toString()}#wechat_redirect`;
}

/**微信扫码登录链接 */
export const wechatLoginUrl = getWechatIframeUrl({ type: WECHAT_SCAN_TYPE.LOGIN });

/** 自由独立版微信扫码登录链接 */
export const independentManualLoginUrl = getWechatIframeUrl({ type: WECHAT_SCAN_TYPE.INDEPENDENT_MANUAL_LOGIN });

/** 获取分销供货商注册链接 */
export const getDropShippingSupplierRegisterUrl = (params: Omit<RegisterSupplierParams, "type">) =>
    getWechatIframeUrl({ type: WECHAT_SCAN_TYPE.REGISTER_SUPPLIER, ...params });

/** 获取供货商扫码登录链接 */
export const getDropShippingSupplierLoginUrl = (params: Omit<SupplierLoginParams, "type">) =>
    getWechatIframeUrl({ type: WECHAT_SCAN_TYPE.SUPPLIER_LOGIN, ...params });

/** 获取自由独立版注册链接 */
export const getIndependentManualRegisterUrl = (params: Omit<RegisterIndependentManualParams, "type">) =>
    getWechatIframeUrl({ type: WECHAT_SCAN_TYPE.REGISTER_INDEPENDENT_MANUAL, ...params });

/** 获取绑定微信子账号链接 */
export const getBindingWeChatUserUrl = (params: Omit<BindingUserParams, "type">) =>
    getWechatIframeUrl({
        type: WECHAT_SCAN_TYPE.BINDING_USER,
        state: params.state,
    });
